__turbopack_context__.v({
  "aspect_ratio__landscape": "ImageBlock-module-scss-module__vxH1ta__aspect_ratio__landscape",
  "aspect_ratio__square": "ImageBlock-module-scss-module__vxH1ta__aspect_ratio__square",
  "aspect_ratio__standard": "ImageBlock-module-scss-module__vxH1ta__aspect_ratio__standard",
  "image_block": "ImageBlock-module-scss-module__vxH1ta__image_block",
  "image_wrapper": "ImageBlock-module-scss-module__vxH1ta__image_wrapper",
});
